import { useId } from "react";
import { useTranslation } from "react-i18next";
import { ClearIcon } from "./clear-icon";
import { SearchIcon } from "./search-icon";

interface TerpenesFilterSearchProps {
	value: string;
	onChange: (value: string) => void;
}

export function TerpenesFilterSearch({
	value,
	onChange,
}: TerpenesFilterSearchProps) {
	const { t } = useTranslation("product");
	const id = useId();
	const placeholder = t("filters.searchTerpenes");

	return (
		<div
			className="w-full pt-2 ml-0.5 mr-0.5"
			data-testid="terpenes-filter-search-wrapper"
		>
			<div className="relative">
				<SearchIcon
					className="pointer-events-none absolute left-3 top-1/2 -translate-y-1/2 text-gray-600"
					aria-hidden="true"
				/>

				<input
					id={id}
					type="text"
					data-testid="terpenes-filter-search"
					placeholder={placeholder}
					value={value}
					onChange={(e) => onChange(e.target.value)}
					className="h-10 w-full rounded-lg bg-gray-100 pl-10 pr-9 py-2.5 text-left text-body-sm text-gray-700 placeholder:text-body-sm placeholder:text-gray-500 focus:outline-none focus:ring-2 focus:ring-ansay-main"
					autoComplete="off"
					onKeyDown={(e) => {
						if (e.key === "Escape" && value) {
							onChange("");
							(e.target as HTMLInputElement).blur();
						}
					}}
					aria-label={placeholder}
				/>

				{value && (
					<button
						type="button"
						data-testid="terpenes-filter-search-clear"
						className="group absolute right-2 top-1/2 -translate-y-1/2 rounded p-1 text-gray-500 hover:text-gray-700 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ansay-main"
						onClick={() => onChange("")}
						aria-label={t("filters.clearTerpenesSearch")}
					>
						<ClearIcon aria-hidden="true" />
					</button>
				)}
			</div>
		</div>
	);
}
